import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetFlowsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setFlowsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
